import React, { useEffect, useRef, useState } from 'react';
import {  Animated, Platform, TouchableOpacity, Vibration, View } from 'react-native';
import { Button, Icon, Text, TextInput } from '../../components';
import { BaseColor, BaseStyle } from '../../config';
import { Switch } from 'react-native-gesture-handler';
import { showMessage } from 'react-native-flash-message';
import Menu from '../../components/Menu';
//import Animated from 'react-native-reanimated';

export default function FormCheckBoxInput({ input, setInput,positions, deleteInput, checkEditing, editing, checkEditableInput, checkAllInputs }) {
    const [state, setState] = useState({ editable: true, ...input, itemOrder: 0 });
    const animationRef = useRef(new Animated.Value(0));
    useEffect(() => {
        !input.edit && checkEditing(input.order);
    }, []);
    const setForm = (name, value) => {
        setState((s) => ({ ...s, [name]: value }));
    };

    const cancel = () => {
        let submitable = checkInput(false, false, true);
        setState((s) => ({ ...s, ...input, editable: false, submitable }));
        setInput({ submitable });
        checkEditing(null);
    };
    const save = () => {
        let submitable = checkInput();
        if (submitable) {
            setInput({
                required: state.required,
                label: state.label,
                description: state.description,
                items: state.items,
                positionId: state.positionId,
                submitable,
            });
            setState((s) => ({ ...s, editable: false, submitable }));
            checkEditing(null);
        }
    };
    const edit = () => {
        if (!checkEditing(input.order)) {
            setState((s) => ({ ...s, ...input, editable: true }));
        }
    };

    const checkInput = (vibrate, light, parentInput) => {
        if (input.istNew) {
            setInput({ istNew: false });
            return;
        }
        let newState = parentInput ? { ...state, ...input } : state;
        let result = newState.label?.length > 0;
        if (!newState.label) {
            newState = { ...newState, labelError: true };
        }

        if (newState.items?.length > 0) {
            newState = {
                ...newState,
                itemsError: false,
                items: newState.items.map((item) => {
                    if (!item.value) {
                        result = false;
                        return { ...item, itemError: true };
                    }
                    return { ...item, itemError: false };
                }),
            };
        } else {
            newState = { ...newState, itemsError: true };
            result = false;
        }

        setState({ ...newState, inputError: !result });
        if ((!result && vibrate !== false) || light) {
            highlight();
            Vibration.vibrate(50);
            setState((s) => ({ ...s }));
        }
        if (result && light) {
            showMessage({
                message: 'Bitte markierte Abfrage zuerst speichern!',
                icon: 'warning',
            });
        }
        return result;
    };
    const highlight = () => {
        Animated.sequence([
            Animated.timing(animationRef.current, {
                toValue: 1,
                // set the duration
                duration: 500,
                useNativeDriver: false,
            }),
            // delay is optional
            Animated.delay(1000),
            Animated.timing(animationRef.current, {
                toValue: 0,
                duration: 500,
                // useNativeDriver:true, might not work with the all properties that you need to animate. true might improve animation performance
                useNativeDriver: false,
            }),
        ]).start();
    };
    const descriptionInput = useRef(null);
    useEffect(() => {
        editing == input.order && checkInput(true, true);
    }, [checkEditableInput]);
    useEffect(() => {
        editing == input.order ? checkInput(true, true) : checkInput();
    }, [checkAllInputs]);

    return (
        <Animated.View
            style={{
                borderBottomColor: BaseColor.grayTransparent,
                borderBottomWidth: 1,
                marginBottom: 10,
                paddingHorizontal: 15,
                backgroundColor: animationRef.current?.interpolate({
                    inputRange: [0, 1],
                    outputRange: ['#fff', '#ccc'],
                }),
            }}
        >
            {!state.editable ? (
                <View>
                    <View style={{ paddingBottom: 5 }}>
                        <Text semibold>{input.label ?? 'Überschrift'}</Text>
                        {input.description && (
                            <Text grayColor footnote>
                                {input.description}
                            </Text>
                        )}
                    </View>
                    <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                        {input.items.map((item, index) => (
                            <TouchableOpacity
                                key={item.value + index}
                                onPress={() => {}}
                                style={{
                                    flexDirection: 'row',
                                    width: '100%',
                                    alignItems: 'center',
                                    paddingVertical: 10,
                                    paddingRight: 15,
                                }}
                            >
                                <View style={{ paddingRight: 5 }}>
                                    <Icon name={'circle'} type={'ft'} size={22} enableRTL={true} color={'#ccccdd'} />
                                </View>
                                <View>
                                    <Text>{item.value}</Text>
                                </View>
                            </TouchableOpacity>
                        ))}
                    </View>
                </View>
            ) : (
                <View style={{ marginTop: 15 }}>
                    <View style={{ padding: 15, backgroundColor: '#00000030' }}>
                        <View style={{ paddingBottom: 5 }}>
                            <Text semibold>
                                {state.label ?? 'Überschrift'}
                                {state.required && ' *'}
                            </Text>
                            {state.description && (
                                <Text grayColor footnote>
                                    {state.description}
                                </Text>
                            )}
                        </View>
                        <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
                            {state.items.map((item, index) => (
                                <TouchableOpacity
                                    key={item.value + index}
                                    onPress={() =>
                                        setState((s) => ({
                                            ...s,
                                            items: s.items.map((i) => (i.order == item.order ? { ...i, selectedd: !i.selectedd } : i)),
                                        }))
                                    }
                                    style={{
                                        flexDirection: 'row',
                                        width: '100%',
                                        alignItems: 'center',
                                        paddingVertical: 10,
                                        paddingRight: 15,
                                    }}
                                >
                                    <View style={{ paddingRight: 5 }}>
                                        <Icon
                                            name={item.selected ? 'checkcircle' : 'circle'}
                                            type={item.selected ? 'ad' : 'ft'}
                                            size={22}
                                            enableRTL={true}
                                            color={item.selected ? BaseColor.primary : "gray"}
                                        />
                                    </View>
                                    <View>{item.value ? <Text>{item.value}</Text> : <Text grayColor>Element</Text>}</View>
                                </TouchableOpacity>
                            ))}
                        </View>
                    </View>
                    <View>
                        <TouchableOpacity
                            onPress={() => setState((s) => ({ ...s, required: !s.required }))}
                            style={{ flexDirection: 'row', alignItems: 'center', paddingVertical: Platform.OS === 'android' ? 0 : 10 }}
                        >
                            <View>
                                <Switch
                                    size={18}
                                    thumbColor={BaseColor.whiteColor}
                                    trackColor={{ true: BaseColor.primary, false: BaseColor.grayTransparent }}
                                    //ios_backgroundColor={BaseColor.primary}
                                    style={{ marginRight: 15 }}
                                    onValueChange={(v) => setForm('required', v)}
                                    value={state.required}
                                />
                            </View>
                            <View>
                                <Text>Pflichtfeld</Text>
                            </View>
                        </TouchableOpacity>
                        {positions?.length>0 && <Menu
                                                                        placeholder={{text:"Wer soll das Feld ausfüllen?"}}
                                                                        activatorStyle={{ width: '100%', marginBottom:15 }}
                                                                        activator={() => (
                                                                            <View
                                                                                style={[
                                                                                    BaseStyle.textInput,
                                                                                    {
                                                                                        backgroundColor: BaseColor.card,
                                                                                        minHeight: 40,
                                                                                        borderRadius: 3,
                                                                                        
                                                                                    },
                                                                                ]}
                                                                            >
                                                                                <View>
                                                                                    {state.positionId ? (
                                                                                        <Text>Für {`${positions?.find(pos=>pos.id==state.positionId).title} (${positions?.find(pos=>pos.id==state.positionId).abbreviation})`}</Text>
                                                                                    ) : (
                                                                                        <Text>Für ADMs (Standard)</Text>
                                                                                    )}
                                                                                </View>
                                                                                <Icon name="chevron-right" size={15} color={BaseColor.gray} style={{ marginRight: 5 }} enableRTL={true} />
                                                                            </View>
                                                                        )}
                                                                        actionItems={[{title:'Standard', abbreviation:'ADM', id:null},...positions]?.map((position) => ({
                                                                            text: `${position.title} (${position.abbreviation})`,
                                                                            leftIcon: () => (
                                                                                <View
                                                                                    style={[
                                                                                        {
                                                                                            backgroundColor: BaseColor.grayLight,
                                                                                            height: 40,
                                                                                            width: 40,
                                                                                            borderRadius: 15,
                                                                                            justifyContent: 'center',
                                                                                            alignItems: 'center',
                                                                                        },
                                                                                    ]}
                                                                                >
                                                                                    <Icon name={"idcard"} type={"ad"} size={20} enableRTL={true} />
                                                                                </View>
                                                                            ),
                                                                            rightIcon: () => (
                                                                                position.id == state.positionId &&<View
                                                                                   
                                                                                >
                                                                                    <Icon name={"check"} type={"ad"} size={20} color={BaseColor.primary} enableRTL={true} />
                                                                                </View>
                                                                            ),
                                                                            action: () =>
                                                                                setState((s) => ({
                                                                                    ...s,
                                                                                    positionId: position.id,
                                                                                })),
                                                                        }))}
                                                                    />}
                        <TextInput
                            onChangeText={(v) => setForm('label', v)}
                            onFocus={() => {
                                setState({
                                    ...state,
                                    labelError: '',
                                });
                            }}
                            placeholder="Überschrift *"
                            success={!state.labelError}
                            value={state.label}
                            style={{ borderRadius: 0, marginBottom: 15, height: 40 }}
                            onSubmitEditing={() => descriptionInput.current.focus()}
                            textError={state.labelError}
                        />
                        <TextInput
                            inputRef={descriptionInput}
                            onChangeText={(v) => setForm('description', v)}
                            onFocus={() => {
                                setState({
                                    ...state,
                                    descriptionError: '',
                                });
                            }}
                            multiline
                            placeholder="Beschreibung/Anmerkung"
                            success={!state.descriptionError}
                            value={state.description}
                            style={{ borderRadius: 0 }}
                            textError={state.descriptionError}
                        />
                        <View style={{ padding: 15, marginTop: 15, borderWidth: 1, borderColor: BaseColor.grayTransparent }}>
                            <View style={{ paddingBottom: 10 }}>
                                <Text>CheckBox Elemente *</Text>
                                {state.itemsError && (
                                    <Text footnote errorColor>
                                        Mind. 1 Element einfügen
                                    </Text>
                                )}
                            </View>
                            {state.items?.map((item) => (
                                <TextInput
                                    key={item.order}
                                    onChangeText={(v) =>
                                        setState((s) => ({ ...s, items: s.items.map((i) => (i.order == item.order ? { ...i, value: v } : i)) }))
                                    }
                                    onFocus={() => {
                                        setState((s) => ({
                                            ...s,
                                            items: s.items.map((i) => (i.order == item.order ? { ...i, itemError: '' } : i)),
                                        }));
                                    }}
                                    placeholder="Element *"
                                    success={!item.itemError}
                                    value={item.value}
                                    style={{ borderRadius: 0, height: 40, marginBottom: 15 }}
                                    textError={state.itemError}
                                    icon={
                                        <TouchableOpacity
                                            onPress={() => setState((s) => ({ ...s, items: s.items.filter((i) => i.order != item.order) }))}
                                        >
                                            <Icon name="close" type="ad" size={20} enableRTL={true} />
                                        </TouchableOpacity>
                                    }
                                    onSubmitEditing={() =>
                                        setState((s) => ({
                                            ...s,
                                            itemsError: false,
                                            itemOrder: s.itemOrder + 1,
                                            items: [...s.items, { value: '', order: s.itemOrder + 1 }],
                                        }))
                                    }
                                />
                            ))}
                            <View style={{ alignItems: 'center' }}>
                                <Button
                                    full
                                    loading={state.creating}
                                    onPress={() =>
                                        setState((s) => ({
                                            ...s,
                                            itemsError: false,
                                            itemOrder: s.itemOrder + 1,
                                            items: [...s.items, { value: '', order: s.itemOrder + 1 }],
                                        }))
                                    }
                                    style={{ height: 40, backgroundColor: BaseColor.grayColor, borderRadius: 0 }}
                                    icon={<Icon name="plus" size={20} type="ad" color={BaseColor.whiteColor} />}
                                >
                                    {' '}
                                    Element hinzufügen
                                </Button>
                            </View>
                        </View>
                    </View>
                </View>
            )}
            <View
                style={{
                    flexDirection: 'row',
                    paddingTop: 5,
                    paddingBottom: 15,
                }}
            >
                <View style={{ flex: 1 }}>
                    {state.inputError ? (
                        <Text footnote errorColor>
                            Pflichtfelder ausfüllen
                        </Text>
                    ) : (
                        <Animated.View style={[{ opacity: animationRef.current }]}>
                            <Text footnote errorColor>
                                Bitte zuerst speichern!
                            </Text>
                        </Animated.View>
                    )}
                    {positions?.length && state.positionId && <View style={{flexDirection:'row'}}>
                                                                
                                                                    <View style={{ justifyContent:'center', alignItems:'center',paddingHorizontal:5, paddingVertical:5, borderRadius:3, backgroundColor:'#f0f0ff'}}><Text caption2 numberOfLines={1}>Für {`${positions?.find(pos=>pos.id==state.positionId).title} (${positions?.find(pos=>pos.id==state.positionId).abbreviation})`}</Text></View>
                                                                
                                                            </View>}
                </View>
                <View
                    style={{
                        flexDirection: 'row',
                        marginTop: 3,

                        paddingVertical: 10,
                        borderRadius: 20,
                        backgroundColor: BaseColor.grayLight,
                    }}
                >
                    <TouchableOpacity
                        style={{ paddingHorizontal: 20, borderRightWidth: 1, borderColor: BaseColor.grayTransparent }}
                        onPress={state.editable ? save : edit}
                    >
                        <Icon name={state.editable ? 'check' : 'edit'} type="ad" size={20} />
                    </TouchableOpacity>
                    <TouchableOpacity style={{ paddingHorizontal: 20 }} onPress={state.editable ? cancel : deleteInput}>
                        <Icon name={state.editable ? 'close' : 'delete'} type="ad" size={20} />
                    </TouchableOpacity>
                </View>
            </View>
        </Animated.View>
    );
}
